<script>
import ModelCreateModal from './modal-create';
import FormsModel from "@/components/forms/vehicle";

export default {
  extends: ModelCreateModal,
  props: {
    modalTitle: {default() { return this.lodash.startCase(this.$t('vehicles.singular')) }},
    resourceRoute: {default: 'vehicles'},
    modelVariable: {default: 'vehicle'},
    form: {default() { return FormsModel; }}
  },
  methods: {
    store(value) {
      return this.$axios.post('/vehicles', value);
    }
  },
}
</script>
